import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { type ContentFrameworkColumn } from "@/lib/composerCore";

export function NewTopicRow({
  workspaceId,
  column,
  nextPosition,
  onChange,
}: {
  workspaceId: string;
  column: ContentFrameworkColumn;
  nextPosition: number;
  onChange: () => void | Promise<void>;
}) {
  const [label, setLabel] = useState("");
  const [saving, setSaving] = useState(false);

  const add = async () => {
    const trimmed = label.trim();
    if (!trimmed) return;
    setSaving(true);
    const { error } = await supabase.from("content_framework_topics").insert({
      workspace_id: workspaceId,
      framework_column_id: column.id,
      label: trimmed,
      position: nextPosition,
    });
    setSaving(false);
    if (error) {
      toast.error(error.message);
      return;
    }
    setLabel("");
    await onChange();
  };

  return (
    <div className="flex items-center gap-2">
      <Input
        value={label}
        onChange={(event) => setLabel(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            void add();
          }
        }}
        placeholder="Add a broad-scope topic"
        disabled={saving}
      />
      <Button size="sm" variant="secondary" onClick={() => void add()} disabled={saving || !label.trim()}>
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
}
